<template>
  <div class="hello">
    <img :src="$t('headerUrl')" class="header" @click="toWalletKnow">
    <div class="container" :class="{'china-fix':isChina}">
      <div style="position: relative" @click="$router.push({name: 'BaseKnow'})">
        <img :src="isDark ? require('../assets/base_dark.png') : require('../assets/base.png')">
        <div>
          <p>{{ $t('basicTitle') }}</p>
          <p>{{ $t('basicSubtitle') }}</p>
        </div>
      </div>
      <div @click="$router.push({name: 'SafeKnow'})">
        <img :src="isDark ? require('../assets/safe_dark.png') : require('../assets/safe.png')">
        <div>
          <p>{{ $t('securityTitle') }}</p>
          <p>{{ $t('securitySubtitle') }}</p>
        </div>
      </div>
      <div @click="$router.push({name: 'WalletManage'})">
        <div>
          <img :src="isDark ? require('../assets/wallet_dark.png') : require('../assets/wallet.png')">
          <span>{{ $t('walletTitle') }}</span>
        </div>
      </div>
      <div @click="$router.push({name: 'TokenManage'})">
        <div>
          <img :src="isDark ? require('../assets/token_dark.png') : require('../assets/token.png')">
          <span>{{ $t('tokenTitle') }}</span>
        </div>
      </div>
      <div @click="$router.push({name: 'Transfer'})">
        <div>
          <img :src="isDark ? require('../assets/transfer_dark.png') : require('../assets/transfer.png')">
          <span>{{ $t('transferTitle') }}</span>
        </div>
      </div>
      <div @click="$router.push({name: 'DeFi'})" v-if="!isChina">
        <div>
          <img :src="isDark ? require('../assets/dex_dark.png') : require('../assets/dex.png')">
          <span>{{ $t('DeFiTitle') }}</span>
        </div>
      </div>
      <div @click="$router.push({name: 'Normal'})" v-if="isChina">
        <div>
          <img :src="isDark ? require('../assets/normal-big_dark.png') : require('../assets/normal-big.png')">
          <span>{{ $t('normalTitle') }}</span>
        </div>
      </div>
      <div @click="$router.push({name: 'Normal'})" v-if="!isChina">
        <img :src="isDark ? require('../assets/normal_dark.png') : require('../assets/normal.png')">
        <span>{{ $t('normalTitle') }}</span>
      </div>
      <div @click="toHmt($t('more'), $t('moreUrl'))" v-if="!isChina">
        <img :src="isDark ? require('../assets/more_dark.png') : require('../assets/more.png')">
        <span>{{ $t('more') }}</span>
      </div>
    </div>
    <div class="test-and-award" @click="toHmt($t('testAndAward'), $t('testAndAwardUrl'))">
      <div class="content-container">
        <p class="title" v-html="$t('testAndAward')"></p>
        <p class="desc" v-html="$t('testAndAwardDesc')"></p>
      </div>
      <img src="../assets/test-and-award.png">
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HelloWorld',
  props: {
    isDark: {
      type: Boolean
    }
  },
  computed: {
    search() {
      return location.search
    },
  },
  data() {
    return {
      isChina: true,
    }
  },
  created() {
    axios.get('https://geoip.transit.finance/', {timeout: 5000}).then(res => {
      this.isChina = res.status === 200 && res.data.country_code === 'CN' && res.data.country_name === 'China'
      localStorage.setItem('China', String(this.isChina))
    }).catch(err => {
      const isChina = localStorage.getItem('China')
      if (isChina) this.isChina = JSON.parse(isChina)
    })
  },
  methods: {
    toWalletKnow() {
      // window.location = 'http://192.168.110.91:8080/WalletKnow/?locale=' + this.$i18n.locale + '#/'
      window.location = 'https://tp-lab.tokenpocket.pro/BaseKnow/?locale=' + this.$i18n.locale + '#/'
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.hello {
  .header {
    width: 100%;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
  }
  .container {
    width: 91.5%;
    margin: 0 auto;
    overflow: hidden;
    >div {
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      &:nth-child(1), &:nth-child(2) {
        margin-top: -10px;
        position: relative;
        >img {
          width: 100%;
          display: block;
        }
        >div {
          position: absolute;
          height: 100%;
          width: 100%;
          top: 0;
          p:first-child {
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: bold;
            font-size: 18px;
            color: #3a3b3d;
            margin-top: 10.7%;
            margin-left: 9.7%;
            line-height: 25px;

            &.dark p {
              color: white;
            }
          }
          p:last-child {
            font-family: PingFang SC, PingFang SC-Medium;
            color: #6f7174;
            font-size: 12px;
            margin-left: 9.7%;
            margin-top: 2px;
            line-height: 17px;
          }
          @media screen and (min-width: 700px) and (max-width: 1024px) {
            p:first-child {
              font-size: 38px;
            }
            p:last-child {
              font-size: 22px;
              margin-top: 30px;
            }
          }
        }
        @media screen and (max-width: 360px) {
          p:first-child {
            font-size: 16px;
          }
          p:last-child {
            width: 112%;
            transform: scale(0.8);
            transform-origin: 0 0;
          }
        }
      }
      &:nth-child(3), &:nth-child(4), &:nth-child(5), &:nth-child(6) {
        padding: 20px 0;
        border: 1px solid #e6e8ea;
        border-radius: 12px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: bold;
        text-align: center;
        color: #3a3b3d;
        div {
          img {
            display: block;
            height: 48px;
            margin: 0 auto 4px;
          }
        }
        @media screen and (max-width: 360px) {
          font-size: 13px;
        }
      }
      &:nth-child(3), &:nth-child(4) {
        margin-top: 16px;
        margin-bottom: 12px;
      }
      &:nth-child(7), &:nth-child(8) {
        margin-top: 16px;
        margin-bottom: 20px;
        height: 63.5px;
        border: 1px solid #e6e8ea;
        border-radius: 12px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: bold;
        color: #3a3b3d;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 24px;
        }
        span {
          margin-left: 8px;
        }
        @media screen and (max-width: 360px) {
          font-size: 13px;
        }
      }
      &:nth-child(2n) {
        margin-left: 3.5%;
      }
      width: 48.25%;
      float: left;
      cursor: pointer;
      @media screen and (min-width: 700px) and (max-width: 1024px) {
        &:nth-child(3), &:nth-child(4), &:nth-child(5), &:nth-child(6) {
          padding: 30px 0;
          border-radius: 12px;
          font-size: 30px;
          margin-top: 10px;
          div {
            img {
              height: 80px;
            }
          }
        }
        &:nth-child(7), &:nth-child(8) {
          height: 100px;
          font-size: 30px;
          margin-top: 20px;
          img {
            height: 40px;
          }
        }
      }
    }
  }
  .test-and-award {
    width: 91.5%;
    margin: 15px auto;
    border: 1px solid #e6e8ea;
    border-radius: 12px;
    position: relative;
    padding: 15px;
    -webkit-tap-highlight-color:rgba(0,0,0,0);
    cursor: pointer;

    .content-container {
      width: 70%;

      .title {
        color: #3A3B3D;
        font-size: 17px;
        font-weight: bold;
        font-family: PingFang SC, PingFang SC-Semibold;

        .earn {
          color: #FF7114;
        }
      }
      .desc {
        color: #9EA0A5;
        margin-top: 2px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Semibold;
      }
    }
    img {
      position: absolute;
      right: 0;
      top: 0;
      width: 30%;
      z-index: 2;
    }


    &::after {
      content: '';
      display: block;
      position: absolute;
      right: 1vw;
      top: 7.8vw;
      width: 23vw;
      height: 7.87vw;
      background: #7795ff;
      border-radius: 50%;
      filter: blur(2px);
      z-index: 1;
    }
  }
}
.dark {
  .hello {
    .container {
      >div {
        &:nth-child(1), &:nth-child(2) {
          >div {
            p:first-child {
              color: #d7dae0;
            }
            p:last-child {
              color: #7e838f;
            }
          }
        }
        &:nth-child(3), &:nth-child(4), &:nth-child(5), &:nth-child(6) {
          border: 1px solid #2d2f33;
          color: #d7dae0;
        }
        &:nth-child(7), &:nth-child(8) {
          border: 1px solid #2d2f33;
          color: #d7dae0;
        }
      }
    }
    .test-and-award {
      border: 1px solid #2d2f33;

      .content-container {
        .title {
          color: #d7dae0;

          .earn {
            color: #FF7114;
          }
        }
        .desc {
          color: #71747a;
        }
      }
    }
  }
}
</style>
